import convertUnitMoney from './convertUnitMoney';

/**
 * Get the sum of a field in a table
 * @param {[{}]} tableData
 * @param {string} fieldName
 * @param {{}} projectData
 * @returns {number}
 */

export const getTableSum = (tableData, fieldName, projectData = undefined) => {
  if (!Array.isArray(tableData) || !tableData.length) {
    return 0;
  }

  if (!fieldName) {
    console.warn('No fieldName provided to getTableSum');
    return null;
  }

  const sum = tableData.reduce((acc, row) => {
    const value = row[fieldName];
    if (value) {
      return acc + convertUnitMoney(value, projectData);
    }
    return acc;
  }, 0);
  return sum;
};
